/* 
  Blog Content Blocks JavaScript
  File: assets/blog-content-blocks.js
*/

document.addEventListener('DOMContentLoaded', function() {
  // FAQ Accordion functionality
  const accordionItems = document.querySelectorAll('.accordion details');
  
  accordionItems.forEach(item => {
    item.addEventListener('toggle', function() {
      if (this.open) {
        // Close all other accordions when opening the current one
        accordionItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.open) {
            otherItem.open = false;
          }
        });
      }
    });
  });
});